
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/living-room-design-app",
      function () {
        return require("private-next-pages/living-room-design-app.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/living-room-design-app"])
      });
    }
  